import React from 'react';
import * as PropTypes from 'prop-types';

const suffixes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const displaySize = (bytes) => {
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  if (!bytes) {
    return '0 B';
  } else {
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + suffixes[i];
  }
};

export const FileSize = ({ size, className }) => {
  return <span className={className ? className : ''}>{`(${displaySize(size)})`}</span>;
};

FileSize.propTypes = {
  size: PropTypes.number.isRequired,
  className: PropTypes.string,
};
